import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Button from 'Components/UI/Button';
import { useRightSidebarContext } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import eventTypes from 'EventTracking/consts/eventTypes';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import categories from 'EventTracking/consts/categories';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  root: {
    display: 'flex',
    paddingBottom: theme.spacing(1),
  },
  prevButton: {
    width: '100%',
    marginRight: theme.spacing(0.5),
  },
  nextButton: {
    width: '100%',
    marginLeft: theme.spacing(0.5),
  },
});

const PaginationBar = ({ classes }) => {
  const { rightSidebarCollection, loadRightSidebarCollectionLink } = useRightSidebarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  function onBackClick() {
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'proposal history pagination back button');
    return loadRightSidebarCollectionLink(rightSidebarCollection.link('prev'));
  }

  function onNextClick() {
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'proposal history pagination next button');
    return loadRightSidebarCollectionLink(rightSidebarCollection.link('next'));
  }

  return (
    <Box className={classes.root}>
      <Button
        className={classes.prevButton}
        color={'primary'}
        variant={'contained'}
        onClick={onBackClick}
        disabled={!rightSidebarCollection.link('prev')}
        test={'facet-plan-proposal-insight-history-prev-button'}
      >
        Previous
      </Button>
      <Button
        className={classes.nextButton}
        color={'primary'}
        variant={'contained'}
        onClick={onNextClick}
        disabled={!rightSidebarCollection.link('next')}
        test={'facet-plan-proposal-insight-history-next-button'}
      >
        Next
      </Button>
    </Box>
  );
};

PaginationBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PaginationBar);
